'use client';

import { Box, Link, Image } from "@chakra-ui/react";
import { useEffect } from 'react';
import ShadowBox from "@/components/partials/ShadowBox";
import { InnerHtml } from "@/components/partials/Helpers";
import analytics from "@/lib/analytics";

export default function Advertising({ ads, padding = '4' }) {
  useEffect(() => {
    analytics('view', ads.advToken);
  }, []);

  return (
    ads && (
      <ShadowBox padding={padding} align="center">
        { ads.advImage && ads.advImage.length && (
          <Link href={ads.advEndpoint} title="Publicidade" onClick={() => analytics('click', ads.advToken)}>
            <Image
              src={ads.advImage}
              alt="Publicidade"
            />
          </Link>
        )}

        { !ads.advImage && ads.advInnerCode && (
          <Box onClick={() => analytics('click', ads.advToken)}>
            <InnerHtml html={ads.advInnerCode}></InnerHtml>
          </Box>
        )}
      </ShadowBox>
    )
  )
}
